/* Home10: use the EXISTING Releasit app block, never simulate its form. */
(function(){
  const onProduct = !!document.querySelector('#home10-cod-position');
  if(!onProduct) return;
  let moving=false;
  function getSource(){return document.querySelector('.apps');}
  function isAppReady(source){
    if(!source) return false;
    const candidates=source.querySelectorAll('button, a, [role="button"]');
    return [...candidates].some(el=>/pide|recibir|comprar|buy|order/i.test((el.innerText||el.textContent||'').trim()));
  }
  function relocate(){
    if(moving) return;
    const target=document.getElementById('home10-cod-position');
    const source=getSource();
    if(!target||!source||!isAppReady(source)) return;
    // Move the *existing* rendered app nodes, retaining listeners and the official app logic.
    moving=true;
    [...source.childNodes].forEach(node=>target.appendChild(node));
    target.classList.add('home10-cod-ready');
    document.documentElement.classList.add('home10-has-cod');
    moving=false;
  }
  function openOfficial(){
    const target=document.getElementById('home10-cod-position');
    const buttons=target?.querySelectorAll('button, a, [role="button"]')||[];
    const official=[...buttons].find(el=>/pide|recibir|comprar|buy|order/i.test(el.innerText||el.textContent||''));
    if(official){official.click();return;}
    target?.scrollIntoView({behavior:'smooth',block:'center'});
  }
  document.addEventListener('click',function(e){if(e.target.closest('[data-cod-shortcut]'))openOfficial();});
  relocate();
  let timer; const observer=new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(relocate,120);});
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',relocate);
  setTimeout(relocate,700);setTimeout(relocate,1800);setTimeout(relocate,4000);
})();
